"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultConfig = void 0;
exports.defaultConfig = {
  channel: "",
  loadOnStart: {
    auth: true,
    checkout: true
  }
};